(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["plp-collection"] && !Shopify.designMode) return;
  try {
    for (const eventName of ['cart:update', 'cart:error']) {
    document.addEventListener(eventName, (event) => {
      if (!(event.target instanceof Element)) return;
      const purchase = event.target.closest('.plp-card__purchase--basic');
      if (!purchase) return;
      if (
        eventName === 'cart:update' &&
        (event.detail?.data?.didError || event.detail?.data?.source !== 'product-form-component')
      )
        return;
      purchase.dispatchEvent(
        new CustomEvent('plp:interaction', {
          bubbles: true,
          detail: {
            experience: 'quick',
            action: eventName === 'cart:update' ? 'add_to_cart_success' : 'add_to_cart_error',
            productId: purchase.closest('.plp-card')?.dataset.plpProduct,
            variantId: purchase.querySelector('[name="id"]')?.value,
            placement: 'collection',
          },
        }),
      );
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest(
      '.plp-collection [data-plp-action="view-product"], .plp-workday [data-plp-action="view-product"], .plp-card__purchase--basic [data-plp-action="learn-more"]',
    );
    if (!link) return;
    const card = link.closest('.plp-card, .plp-workday__card');
    card?.dispatchEvent(
      new CustomEvent('plp:interaction', {
        bubbles: true,
        detail: {
          experience: card.dataset.plpExperience || document.querySelector('.plp-collection')?.dataset.plpExperience,
          action: link.dataset.plpAction === 'learn-more' ? 'learn_more' : 'view_product',
          productId: card.dataset.plpProduct,
          placement: card.closest('.plp-workday') ? 'workday' : 'collection',
        },
      }),
    );
  });

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
